import { render, staticRenderFns } from "./show_preview.vue?vue&type=template&id=10be6fbe&scoped=true"
import script from "./show_preview.vue?vue&type=script&lang=ts"
export * from "./show_preview.vue?vue&type=script&lang=ts"
import style0 from "./show_preview.vue?vue&type=style&index=0&id=10be6fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be6fbe",
  null
  
)

export default component.exports